import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';

export default {
  getInstitutionConfiguration() {
    return axiosPlataformaClient.custAxios().get('settings/institution/configuration');
  },
  getCategoryTypes() {
    return axiosPlataformaClient.custAxios().get('settings/institution/configuration/category-types');
  },
  getTopicTypes() {
    return axiosPlataformaClient.custAxios().get('settings/institution/configuration/topic-types');
  }
};
